import { render, staticRenderFns } from "./altaClinicaV2.vue?vue&type=template&id=509ab326&scoped=true"
import script from "./altaClinicaV2.vue?vue&type=script&lang=js"
export * from "./altaClinicaV2.vue?vue&type=script&lang=js"
import style0 from "./altaClinicaV2.vue?vue&type=style&index=0&id=509ab326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ab326",
  null
  
)

export default component.exports